<template>
  <div class="content-body">
    <div class="container-fluid">
      <Breadcrumb name="Send Money" :breadcrumb="breadcrumb" />
      <!-- row -->
      <div class="row">
        <div class="col-xl-12 col-xxl-12">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Send Money</h4>
            </div>
            <div class="card-body">
              <div class="basic-form">
                <Form @submit="sendCall" :validation-schema="schema">
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Email Address or Phone</label>
                    <div class="col-sm-9">
                      <Field class="form-control" type="text" name="emailOrPhone" rules="required" placeholder="Email"
                      />
                      <ErrorMessage name="emailOrPhone"/>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-10">
                      <Button class="btn btn-primary" :loading="loader" >Send</Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      loader: false,
      emailOrPhone: '',
      breadcrumb:[
        {name: 'App'},
        {name: 'Send Money'}
      ],

    }
  },
  methods: {
    sendCall(values){
      this.emailOrPhone = values.emailOrPhone
      let data = values
      this.loader = true
      this.makeRequest('post','v1/verify-email-phone',data).then(callResponse => {

        this.loader = false
        if(!callResponse.error){
          let code = callResponse.response.data.code;

          if(code == 200){
            this.$store.commit("setUserGeneralInfoData",callResponse.response.data.data);
            this.$store.commit("setUserEmailOrPhoneData",this.emailOrPhone);
            this.$router.push({name: 'send-money-initiate', params: { emailOrPhone: this.emailOrPhone,msg: callResponse.response.data.message }})
          }
          else if (code == 401) {
            this.$router.push({name: 'send-otp'});
          }
        }

      });

    },
  },
}
</script>

